import { render, staticRenderFns } from "./comfirmUser.vue?vue&type=template&id=ce8ab454&"
import script from "./comfirmUser.vue?vue&type=script&lang=js&"
export * from "./comfirmUser.vue?vue&type=script&lang=js&"
import style0 from "./comfirmUser.vue?vue&type=style&index=0&id=ce8ab454&prod&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports